<template>
  <div class="loading_container">
    <svg
      :width="width"
      :height="height"
      viewBox="0 0 50 50"
      preserveAspectRatio="xMidYMid meet"
    >
      <circle
        cx="25"
        cy="25"
        r="22"
        fill="none"
        stroke-width="3"
        :stroke="outSideColor"
        stroke-dasharray="34"
        stroke-linecap="round"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          values="0 25 25;360 25 25"
          :dur="`${dur}s`"
          repeatCount="indefinite"
        />
        <animate
          attributeName="stroke"
          :values="outSideColorAnimation"
          :dur="`${dur}s`"
          repeatCount="indefinite"
        />
      </circle>
      <circle
        cx="25"
        cy="25"
        r="12"
        fill="none"
        stroke-width="3"
        :stroke="inSideColor"
        stroke-dasharray="19"
        stroke-linecap="round"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="360 25 25"
          to="0 25 25"
          :dur="`${dur}s`"
          repeatCount="indefinite"
        />
        <animate
          attributeName="stroke"
          :values="inSideColorAnimation"
          :dur="`${dur}s`"
          repeatCount="indefinite"
        />
      </circle>
    </svg>
    <slot></slot>
  </div>
</template>
<script setup>
import { defineProps, computed } from 'vue';
const props = defineProps({
  width: {
    type: [String, Number],
    default: 20,
  },
  height: {
    type: [String, Number],
    default: 20,
  },
  outSideColor: {
    type: [String],
    default: '#3bebcb',
  },
  inSideColor: {
    type: [String],
    default: '#02bcfe',
  },
  dur: {
    type: Number,
    default: 2,
  },
});
const outSideColorAnimation = computed(() => {
  return `${props.inSideColor};${props.outSideColor};${props.inSideColor}`;
});
const inSideColorAnimation = computed(() => {
  return `${props.outSideColor};${props.inSideColor};${props.outSideColor}`;
});
</script>
<style scoped>
.loading_container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
